<template>
  <div>
    <v-card max-width="1000" class="mx-auto" elevation="0">
      <v-subheader>Shopping History</v-subheader>

      <v-card flat>
        <v-container>
          <v-simple-table v-if="itemsTmp != null" style="color: orange">
            <tbody>
              <tr v-for="itemTmp in itemsTmp" :key="itemTmp.id">
                <td>
                  Invoice: {{ itemTmp.invoice_number }}
                  <div class="orange--text title">
                    Rp. {{ itemTmp.total_bill.toLocaleString("id-ID") }}
                  </div>
                  <small>date: {{ itemTmp.updated_at }}</small>
                </td>
                <td>
                  <small> Waiting for payment</small>
                </td>
                <td>
                  <v-btn
                    x-small
                    color="orange"
                    @click="onViewTmp(itemTmp)"
                    class="mx-0 white--text"
                  >
                    View
                  </v-btn>
                  <br />
                  <small>{{ itemTmp.status }}</small>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-simple-table>
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td>
                  Invoice: {{ item.invoice_number }}
                  <div class="black--text title">
                    Rp. {{ item.total_bill.toLocaleString("id-ID") }}
                  </div>
                  <small>date: {{ item.updated_at }}</small>
                </td>
                <td>
                  <small>
                    <v-btn
                      :href="item.shipping_services"
                      target="_blank"
                      class="mx-0 white--text"
                      elevation="0"
                      x-small
                      rounded
                      color="blue"
                    >
                      Tracking
                    </v-btn>
                    <br />
                    Number traking:
                    {{ item.tracking_number }}</small
                  >
                </td>
                <td>
                  <v-btn
                    x-small
                    color="blue"
                    @click="onView(item)"
                    class="mx-0 white--text"
                  >
                    View
                  </v-btn>
                  <br />
                  <small>{{ item.status }}</small>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-container>
        <template>
          <v-dialog v-model="dialogView" persistent max-width="300" id="dialogView">
            <v-responsive class="overflow-y-auto" max-height="calc(90vh - 300px)">
              <v-card>
                <v-btn
                  icon
                  dark
                  rounded
                  @click="dialogView = false"
                  color="#1B5E20"
                  elevation="0"
                  large
                  class="black--text"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-card-text style="width: 300px; height: 500px">
                  <small>
                    <table>
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Name</th>
                          <th>Price</th>
                          <th>Discount</th>
                          <th>Qty</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in product_order"
                          :key="'product_order' + index"
                        >
                          <td>
                            {{ index + 1 }}
                          </td>
                          <td>
                            {{ item.name_product }}
                          </td>
                          <td>{{ item.price_product }}</td>
                          <td v-if="item.promotion_name != null">
                            {{ item.promotion_name }}
                          </td>
                          <td v-else></td>
                          <td>
                            {{ item.quantity }}
                          </td>
                          <td>{{ item.quantity * item.price_product }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table style="float: right">
                      <tr>
                        <th>Tax</th>
                        <td>Rp {{ orders.tax }}</td>
                      </tr>

                      <tr>
                        <th>Courier</th>
                        <td>Rp {{ orders.total_bill - courier }}</td>
                      </tr>
                      <tr>
                        <th>Tota Billl</th>
                        <td>Rp {{ orders.total_bill }}</td>
                      </tr>
                    </table>
                  </small>
                </v-card-text>
              </v-card>
            </v-responsive>
          </v-dialog>
        </template>
        <v-card-text class="text-center">
          <v-btn
            rounded
            color="white"
            outlined
            elevation="5"
            large
            @click="getMyOrder(10)"
          >
            <v-list-item-title class="black--text">Muat Lebih Banyak</v-list-item-title>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-card>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      items: [],
      itemsTmp: [],
      selectedFile: null,
      id: null,
      sum: 0,
      dialogView: false,
      orders: "",
      product_order: [],
      courier: 0,
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
  methods: {
    ...mapActions({
      setAlert: "alert/set",
    }),
    onFileSelected(event) {
      this.selectedFile = event;
    },
    onViewTmp(itemTmp) {
      this.courier = 0;
      this.id = itemTmp.id;
      this.dialogView = true;
      let formData = new FormData();
      formData.set("id", this.id);
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/orders/report-order-tmp";
      this.axios
        .post(url, formData, config)
        .then((response) => {
          let { data } = response.data;
          this.orders = data;
          this.product_order = response.data.product_order;
          Array.from(this.product_order).forEach(
            (element) => (this.courier += element.quantity * element.price_product)
          );
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    onView(item) {
      this.courier = 0;
      this.id = item.id;
      this.dialogView = true;
      let formData = new FormData();
      formData.set("id", this.id);
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/orders/report-order";
      this.axios
        .post(url, formData, config)
        .then((response) => {
          let { data } = response.data;
          this.orders = data;
          this.product_order = response.data.product_order;
          Array.from(this.product_order).forEach(
            (element) => (this.courier += element.quantity * element.price_product)
          );
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    onUpload(item) {
      this.id = item.id;
      const uploadImage = new FormData();
      uploadImage.append("image", this.selectedFile, this.selectedFile.name);
      uploadImage.append("order_id", this.id);

      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      this.axios
        .post("/upload_evidence_transfer ", uploadImage, config)
        .then((response) => {
          let { data } = response;
          this.setAlert({
            status: true,
            text: data.message,
            color: "success",
          });
          this.selectedFile = null;
          this.clear();
        })
        .catch((error) => {
          let { data } = error.response;
          this.setAlert({
            status: true,
            text: data.message,
            color: "error",
          });
          this.selectedFile = null;
        });
    },
    clear() {
      this.$refs.fileOrder.reset();
    },
    getMyOrder(count) {
      if (this.sum == 0) {
        this.sum = 10 + count;
      } else {
        this.sum = this.sum + count;
      }
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let add = this.sum;
      let formData = new FormData();
      formData.set("add", add);
      this.axios
        .post("/my-order-count", formData, config)
        .then((response) => {
          let { data } = response.data;
          this.items = data;
          this.itemsTmp = response.data.orderTmp;
        })
        .catch((error) => {
          let { data } = error.response;
          this.setAlert({
            status: true,
            text: data.message,
            color: "error",
          });
        });
    },
  },
  mounted() {
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.api_token,
      },
    };
    this.axios
      .get("/my-order", config)
      .then((response) => {
        let { data } = response.data;
        this.items = data;
        this.itemsTmp = response.data.orderTmp;
      })
      .catch((error) => {
        let { data } = error.response;
        this.setAlert({
          status: true,
          text: data.message,
          color: "error",
        });
      });
  },
};
</script>
